// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__5Z4bt","row":"styles_row__2iO_d"};